import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';

// If we ever use HubSpot DB for anything else, we can create a useHubSpotDb hook and move this type with type parameters, but for now this is fine

export type HubSpotNewsItem = {
  headline: string;
  content: string;
  message_cta?: string;
  link_cta?: string;
};

export type HubSpotDbResponse = {
  results: {
    id: string;
    childTableId: string;
    createdAt: string;
    name: string | null;
    path: string | null;
    publishedAt: string;
    initialPublishedAt: number;
    renderOrder: number;
    isEdited: boolean;
    language: null;
    translatedFromId: null;
    groupId: null;
    accessRuleType: null;
    accessRuleIds: [];
    analyticsPageId: null;
    createdByUserId: number;
    updatedByUserId: number;
    internalUpdatedAt: number;
    internalUpdatedByUserId: number;
    publishStatus: string;
    updatedAt: string;
    deletedAt: number;
    values: HubSpotNewsItem;
    displayIndex: number;
    translations: [];
    isSoftEditable: boolean;
  }[];
  total: number;
  type: string;
  paging?: {
    next: {
      offset: number;
      link: string;
    };
  };
};

const hubspotTableIds: Record<(typeof PRISMA_CONFIG)['stage'], string> = {
  prod: '1065600248',
  test: '1020617951',
  kon: '1020617951',
  int: '1020617951',
  ent: '1020617951',
  local: '1020617951',
  storybook: '123456789',
};

const hubspotTableId = hubspotTableIds[PRISMA_CONFIG.stage];

export const useOptionalDashboardNews = () => {
  const monolithUser = useOptionalAuthenticatedMonolithUser();

  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<HubSpotDbResponse>({
        ...baseConfig,
        method: 'GET',
        url: `https://api.hubapi.com/cms/v3/hubdb/tables/${hubspotTableId}/rows?portalId=144146512`,
        timeout: 4000,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: 'dashboard-news',
      onError(error) {
        return error;
      },
    }
  );

  useEffect(() => {
    if (monolithUser?.isShipper) return;
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  if (monolithUser?.isShipper) return;

  return request;
};

export type DashboardNewsRequest = ReturnType<typeof useOptionalDashboardNews>;
